import React from "react";
import { CV } from "../components/cv";
import JohanImg from "@/assets/images/johan-r.png";

export default function CVJohanRosengren() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Johan Rosengren";
  }, []);

  return (
    <CV
      name="Johan Rosengren"
      title="Senior UX Designer · Co-founder"
      subtitle="UX and e-commerce design that lifts conversion — trusted by Kjell & Company, Thule and Fitness24Seven"
      photo={JohanImg}
      summary="Experienced Senior UX Designer & Co-founder of BoldBrave. Proficient in UX Design, Figma, JavaScript, React, TypeScript, and more. Led impactful projects for Fitness24Seven, Kjell & Company, Ålö/Quicke, and Thule, focusing on e-commerce flows, design systems, and user analysis. Extensive UX roles at Knowit Experience and Avensia, shaping user trust, navigation, and checkout efficiency. Swedish native, fluent in English."
      skills={{
        "Design": ["UX Design", "UX Research", "UI Design", "Figma"],
        "Development": ["React", "JavaScript", "TypeScript", "CSS", "HTML", "C#"],
        "Analytics": ["GA4", "GTM", "Hotjar", "Crazy Egg"],
        "Tools": ["GIT"],
      }}
      experience={[
        {
          role: "Senior UX Designer / Owner",
          company: "BoldBrave",
          period: "2019 - Present",
          description:
            "Co-owner of BoldBrave. Works with business development, but also responsible for developing the company's graphic profile.",
          highlights: [
            "StickerAPP (2024 - Present): Improving purchasing flow and checkout experience. Optimizing user journeys, streamlining payment processes, resulting in increased conversion rates",
            "Fitness24Seven (2020 - Present): Designed new registration flow for potential members and new app for members on iOS/Android",
            "Kjell & Company (2018 - Present): Developing new concepts and flows for e-commerce. Helping users find what they're looking for with painless shopping experience. Development in React/TypeScript",
            "Ålö/Quicke (2023): Setting up design systems and flows for e-commerce, analysis of existing users in GA/Hotjar",
            "Thule (2021 - 2022): Setting up design systems and flows for e-commerce and extranet, user analysis in GA/Hotjar",
          ],
        },
        {
          role: "Senior UX-designer",
          company: "Knowit Experience",
          period: "2016 - 2018",
          description:
            "Worked as UX designer close and early in customer processes. Involved in sales to new customers and setting up boilerplates in projects.",
          highlights: [
            "Studentlitteratur: Developed concepts for new e-commerce, categorization of products, design systems and flows",
            "AJ Produkter (2016): Completely new design including design systems and flows for e-commerce",
            "Vagabond: Further developed design from communication agency, set up front-end framework in Webpack",
            "Bona: Setting up design systems and flows for e-commerce",
          ],
        },
        {
          role: "UX-designer / Frontend developer",
          company: "Avensia",
          period: "2012 - 2016",
          description:
            "Worked initially as front-end developer, moving towards design. Focus on e-commerce, building knowledge around user behavior on e-commerce sites. Focus on user trust, navigation/search in categories and efficient checkout flows. Ended working exclusively with sales and start-up of new customer projects.",
          highlights: [
            "Ahlsell (2015 - 2016): Part of team developing B2B e-commerce with new flows. Responsible for design and ballpark for development team",
            "Toyota Material Handling (2016): Completely new design including design systems and flows for e-commerce",
            "Lekolar (2015): Completely new design including design systems and flows for e-commerce",
            "Bona (2012 - 2014): Design systems and flows for e-commerce, both B2C and B2B",
            "Menigo (2016): Completely new design including design systems and flows for e-commerce",
            "Bygghemma (2012): First pure UX design assignment. Set up prototype, flows and design system for responsive e-commerce",
            "Kjell & Company (2012 - 2016): Started with development, got more responsibility for UX design and new responsive e-commerce",
          ],
        },
        {
          role: "Frontend developer",
          company: "ReadSoft",
          period: "2007 - 2012",
          description:
            "Part of global marketing department. Produced marketing material, videos and sat as editor for both public and internal web. Started developer career when involved in development of new website launched in 2012.",
        },
      ]}
      education={[
        {
          degree: "UX Design",
          institution: "Berghs School of Communication",
          year: "2016",
        },
        {
          degree: "B.Sc Multimedia Engineering",
          institution: "Lund tekniska högskola",
          year: "2002 - 2006",
        },
      ]}
    />
  );
}
